module.exports = __webpack_public_path__ + "img/AW.b5f7247c.png";